import type { MantineColorsTuple } from '@mantine/core';

// Design tokens for the beta design system.
// Calm, functional, desktop-first. Amber accent nods to Pokémon.

export const betaColors: { accent: MantineColorsTuple; neutral: MantineColorsTuple } = {
  accent: [
    '#fffbeb', // 0
    '#fef3c7', // 1
    '#fde68a', // 2
    '#fcd34d', // 3
    '#fbbf24', // 4
    '#f59e0b', // 5
    '#d97706', // 6
    '#b45309', // 7
    '#92400e', // 8
    '#78350f', // 9
  ],
  neutral: [
    '#f8fafc', // 0
    '#f1f5f9', // 1
    '#e2e8f0', // 2
    '#cbd5e1', // 3
    '#94a3b8', // 4
    '#64748b', // 5
    '#475569', // 6
    '#334155', // 7
    '#1e293b', // 8
    '#0f172a', // 9
  ],
};

// Flat series accent colors (small accents only). Keys match backend series slugs.
export const seriesColors: Record<string, string> = {
  scarletviolet: '#eb154f',
  swordshield: '#5dc8f2',
  sunmoon: '#fec86a',
  xy: '#0078af',
  blackwhite: '#4a4a4a',
  pop: '#dd1111',
  platinum: '#68685c',
  diamondpearl: '#42bafe',
  exteammagmarocketvsplasma: '#3050c8',
  megaevolution: '#9f7bea',
  mega: '#9f7bea',
  promotional: '#e0a800',
  other: '#8e8e93',
};

export function getSeriesColor(series?: string | null): string {
  if (!series) return seriesColors.other;
  // Keys are backend slugs ("scarletviolet") but callers pass display names
  // ("Scarlet & Violet") — normalize so both resolve instead of falling to gray.
  const key = series.toLowerCase().replace(/[^a-z0-9]/g, '');
  return seriesColors[key] ?? seriesColors.other;
}